// export const api = 'http://192.168.30.7:3800'
// export const api = 'http://192.168.43.123:3100'
// export const api = 'http://192.168.100.47:3100'
// export const api = 'http://192.168.30.37:3800'
// export const api = 'http://192.168.30.9:3100'
// export const api = 'http://psvdemooracleaccounting.ap-southeast-1.elasticbeanstalk.com/'
// export const api = 'https://psv-endpoint.psvsystem.com'
export const api = 'https://psv-api.psvsystem.com'


